import { daysAgo } from 'tio-common/utils/date';

/** Constants for Predefined Filter Sets */
export const BASE_QUERY = {
  applicationCreatedAtEnd: '',
  applicationCreatedAtStart: '',
  applicationStates: '',
  approverId: '',
  coursesBeginDate: '',
  coursesEndDate: '',
  employeeId: '',
  includeCourses: false,
  includeInvoiceDate: false,
  includePayments: false,
  inCollections: false,
  paymentStates: '',
  paymentYear: '',
  programTemplateId: '',
  showIndividualApplications: false,
  terminatedEmployees: false,
  excludeTermVerified: false,
  courseCashProgramsOnly: false,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
  ].join(','),
  columnOrder: [],
};

export const PROGRAMS_DEFAULT = {
  ...BASE_QUERY,
  showIndividualApplications: false,
  selectedColumns: [
    'employee_name_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
  ],
};

/** Default filter state for general applications view */
export const APPLICATIONS_DEFAULT = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationCreatedAtStart: '', // Empty to show all applications
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_created_at_date',
  ].join(','),
};

export const READY_FOR_PAYMENT = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationStates: 'TAS.ApplicationState.FULFILLED',
  paymentStates: 'tas_application_payment_pending_amount_integer',
  includePayments: true,
  excludeNonVoucherPrograms: false,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_payment_pending_amount_integer',
    'tas_application_payment_final_approved_total_amount_integer',
  ].join(','),
};

export const VOUCHER_READY_FOR_PAYMENT = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationStates: 'TAS.ApplicationState.ATTEND',
  paymentStates: 'tas_application_payment_pending_amount_integer',
  includePayments: true,
  excludeNonVoucherPrograms: true,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_payment_pending_amount_integer',
    'tas_application_payment_final_approved_total_amount_integer',
  ].join(','),
};

export const COURSES_IN_PROGRESS = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationStates: 'TAS.ApplicationState.ATTEND',
  includeCourses: true,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_field_courses_begin_date_date',
    'tas_application_field_courses_end_date_date',
  ].join(','),
};

export const COURSES_MISSING_DOCUMENTATION = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationStates: 'TAS.ApplicationState.ATTEND',
  coursesEndDate: daysAgo(7),
  includeCourses: true,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_field_courses_begin_date_date',
    'tas_application_field_courses_end_date_date',
  ].join(','),
};

export const TERMINATED_EMPLOYEES = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  terminatedEmployees: true,
  includeCourses: true,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'employment_end_date',
    'tas_application_field_courses_begin_date_date',
    'tas_application_field_courses_end_date_date',
  ].join(','),
};

export const PAYMENTS = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  includePayments: true,
  applicationStates: 'TAS.ApplicationState.FULFILLED',
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_payment_paid_amount_integer',
    'tas_application_payment_pending_amount_integer',
    'tas_application_payment_final_approved_total_amount_integer',
  ].join(','),
};

export const INVOICE_DATE = {
  ...BASE_QUERY,
  showIndividualApplications: true,
  applicationCreatedAtStart: '', // Empty to show all applications
  includeInvoiceDate: true,
  selectedColumns: [
    'employee_name_keyword',
    'employee_payroll_id_keyword',
    'tas_program_template_field_program_name_keyword',
    'tas_program_instance_field_school_institution_name_keyword',
    'tas_application_id_keyword',
    'tas_application_state_keyword',
    'tas_application_created_at_date',
  ].join(','),
};
